module.exports = __webpack_public_path__ + "static/fill-19c59bebf2be898286de3be87dc2370c.svg";